export const getPlatformCampaignsStore = state => state.platformCampaigns;
export const getPlatformCampaigns = state => state.platformCampaigns.data;
export const getLoadedState = state => state.platformCampaigns.loaded;
